<ng-container *ngIf="dataStream$ | async as saleList">
  <div class="title-container">
    <span class="title">{{
      'articleSearchList.client' | translate
    }}</span>
    <span class="title">{{
      'articleSearchList.transaction' | translate
    }}</span>
    <span class="title">{{
      'articleSearchList.itemColour' | translate
    }}</span>
    <span class="title">{{
      'articleSearchList.itemSize' | translate
    }}</span>
    <span class="title">{{ 'articleSearchList.date' | translate }}</span>
  </div>
  <cdk-virtual-scroll-viewport
    *ngIf="this.currentArray.length > 0"
    [itemSize]="100"
    (scrolledIndexChange)="nextBatch()">
    <li *cdkVirtualFor="let sale of saleList; let index = index;">
      <mat-card
        class="transaction-container"
        (click)="transactionClicked(sale)">
        <div class="info-container">
          <div class="info">
            <span class="name text">{{ sale.transactions[0].name }}</span>
            <span class="text">{{ sale.transactions[0].phone }}</span>
            <div class="ellipsis-text-box">
              <span class="ellipsis-text">{{ sale.transactions[0].email }}</span>
            </div>
          </div>
          <div class="info">
            <span class="text">{{'articleSearchList.retail' | translate}}</span>
            <span class="text">{{'articleSearchList.transaction' | translate}}</span>
            <span class="text">{{ sale.transactions[0].id }}</span>
          </div>
          <div class="info">
            <span class="text" *ngFor="let item of getItemColour(sale.transactions[0])">{{item}}</span>
          </div>
          <div class="info">
            <span class="text" *ngFor="let item of getItemSize(sale.transactions[0])">{{item}}</span>
          </div>
          <div class="info">
            <span class="text">{{ sale.transactions[0].transactionDate }}</span>
          </div>
        </div>
      </mat-card>
    </li>
    <div class="spinner" *ngIf="loading">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </cdk-virtual-scroll-viewport>
</ng-container>
<div class="spinner" *ngIf="loading && currentArray.length === 0">
  <mat-spinner></mat-spinner>
</div>
